module.exports = __webpack_public_path__ + "static/media/green_credits.d63d8462.jpg";